"use client"

import { MotionConfig } from "framer-motion"

/**
 * Makes every Framer Motion animation in the tree honour the reader's OS
 * "reduce motion" setting.
 *
 * `reducedMotion="user"` disables transform and layout animations while
 * letting opacity and colour transitions through, which is the distinction
 * the setting is actually asking for — a fade is not what makes people
 * motion-sick, a 60s sideways crawl is.
 *
 * Applied once at the root instead of per-component so a new `motion.div`
 * added later is covered by default rather than by remembering to opt in.
 */
export function MotionProvider({ children }: { children: React.ReactNode }) {
    return <MotionConfig reducedMotion="user">{children}</MotionConfig>
}
